var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlotBattles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49963 17.92L5.57963 19L3.27963 21.28C2.99963 21.57 2.49963 21.57 2.21963 21.28C1.93963 20.99 1.92963 20.5 2.21963 20.22L4.49963 17.92ZM18.2896 5.92V4.5L11.9996 10.79L5.70963 4.5V5.92L11.2896 11.5L7.49963 15.31C6.31963 14.47 4.67963 14.57 3.62963 15.62L7.87963 19.87C8.92963 18.82 9.02963 17.18 8.19963 16L18.2896 5.92ZM21.7796 20.22L19.4996 17.92L18.4196 19L20.7196 21.28C20.9996 21.57 21.4996 21.57 21.7796 21.28C22.0596 20.99 22.0696 20.5 21.7796 20.22ZM16.4996 15.31L13.4196 12.21L12.7096 12.92L15.8096 16C14.9696 17.18 15.0696 18.82 16.1196 19.87L20.3696 15.62C19.3196 14.57 17.6796 14.47 16.4996 15.31Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotBattles);
export default __webpack_public_path__ + "static/media/slotBattles.e6eeec39c43aa7edb602791705752368.svg";
export { ForwardRef as ReactComponent };